import { Autocomplete, TextField } from "@mui/material";

import { Controller } from "react-hook-form";

interface IFormInput {
    name: string;
    label: string;
    control: any;
    error: any;
    disabled?: boolean;
    readOnly?: any;
    options: { value: string | number; label: string }[];
    concatWithID?: boolean;
    limitTags?: number;
    renderOption?: any;
    disableCloseOnSelect?: boolean;
    onClick?: any;
}

export default function AutoCompleteComponent({
    name,
    label,
    options,
    control,
    error,
    readOnly,
    disabled,
    concatWithID: concat,
    limitTags,
    renderOption,
    disableCloseOnSelect,
    onClick,
}: IFormInput) {
    return (
        <Controller
            name={name}
            control={control}
            defaultValue={[]}
            render={({ field: { onChange: renderChange, value: valueProp } }) => {
                return (
                    <Autocomplete
                        openText="Abrir"
                        closeText="Fechar"
                        noOptionsText="Nenhum registro"
                        multiple
                        size="small"
                        readOnly={readOnly}
                        disableCloseOnSelect={disableCloseOnSelect}
                        limitTags={limitTags}
                        disabled={disabled}
                        options={options}
                        value={valueProp || []}
                        getOptionLabel={(opt) => {
                            if (concat) {
                                if (typeof opt === "object") {
                                    return `${opt.value} - ${opt?.label}`;
                                }
                                if (typeof opt === "string") {
                                    return options.find((op) => String(op.value) === String(opt))?.label || opt;
                                }
                            }

                            return opt?.label || options.find((op) => String(op.value) === String(opt))?.label || opt;
                        }}
                        isOptionEqualToValue={(option, value) => {
                            return String(option.value) === String(value);
                        }}
                        onChange={(_, value) => {
                            const newValue = !!value
                                ? value.map((opt) => {
                                      const isNewValueString = typeof opt === "string";
                                      return isNewValueString ? opt : String(opt.value);
                                  })
                                : [];
                            renderChange(newValue);
                        }}
                        renderInput={(params) => {
                            const { InputProps, ...restParams } = params;
                            const { startAdornment, ...restInputProps } = InputProps;
                            return (
                                <TextField
                                    {...restParams}
                                    margin="normal"
                                    size="small"
                                    error={!!error && !!error[name]}
                                    helperText={!!error && error[name]?.message}
                                    label={label}
                                    onClick={onClick}
                                    InputProps={{
                                        ...restInputProps,
                                        startAdornment: (
                                            <div
                                                style={{
                                                    maxHeight: 80,
                                                    overflowY: "auto",
                                                }}
                                            >
                                                {startAdornment}
                                            </div>
                                        ),
                                    }}
                                />
                            );
                        }}
                        renderOption={renderOption}
                    />
                );
            }}
        />
    );
}
